export const MaxPreferredQueueSize = 20

export const CreateBookingSteps = Object.freeze({
  DetailsStep: 1,
  SelectEducatorsStep: 2,
})

export const CertChipLimits = {
  isMediumOrLower: 6,
  isLargeOrHigher: 8,
}

export const TruncationCert = {
  certId: 'certifications-overflow-indicator',
  typeName: '...',
}
